export const perPageInitialData = [
  { value: 10, name: '10', selected: true },
  { value: 15, name: '15', selected: false },
  { value: 20, name: '20', selected: false },
  { value: 30, name: '30', selected: false },
  { value: 40, name: '40', selected: false },
  { value: 50, name: '50', selected: false },
  { value: 100, name: '100', selected: false }
]
